export default {
  data(){
    return {
      emitMappings: {
        "recipientDetailsDisabled": "scrollToRecipientDetails",
        "sameOrderDisabled": "scrollToSameAddress",
        "deliveryWindowDisabled": "scrollToDeliveryWindow",
        "cardMessageDisabled": "scrollToCardMessage",
        "subsCollectionDisabled" : "scrollToSubsCollection",
        "subsSizeDisabled" : "scrollToSubsSize",
        "ongoingFrequencyDisabled" : "scrollToOngoingFrequency",
        "sub3MonthFrequencyDisabled": "scrollToSub3Frequency",
        "sub6MonthFrequencyDisabled": "scrollToSub6Frequency",
        "subsFrequencyDisabled" : "scrollToSubsFrequency",
      }
    }
  },
  methods: {
    scrollToFirstError(disabledSteps) {
      this.$nuxt.$emit("runInputFieldsValidation");

      for(const key in disabledSteps) {
        if (disabledSteps[key]) {
          this.$nuxt.$emit(this.emitMappings[key]);
          break;
        }
      }

    }
  }
}